import { type Model, hydrateModel } from "@foundation/hydrate-model";
import {
  HydrateContent,
  HydrateDataType,
} from "@foundation/hydrate-model/lib/extract";

export default function hydrateArray(data: HydrateDataType, model: Model) {
  if (!data || !Array.isArray(data))
    return {
      data: null,
      errors: [],
    };

  const hydrationErrors: Array<string> = [];
  const hydratedData = data?.map((item: HydrateContent) => {
    if (!item) {
      return null;
    }

    const { model: hydratedItem, errors } = hydrateModel(item, model, {}, true);

    if (!hydratedItem || errors.length > 0) {
      hydrationErrors.push(...errors);

      return null;
    }

    return hydratedItem;
  });

  return {
    data: hydratedData.filter((item) => item !== null),
    errors: hydrationErrors,
  };
}
